































































































































































































































import Document from '@/datatypes/document';
import Event from '@/datatypes/event';
import Recipient from '@/datatypes/recipient';
import DocumentService from '@/services/document/DocumentService';
import { Component, Vue, Watch } from 'vue-property-decorator';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import DocumentEvents from '@/views/Documents/Events.vue';
import DocumentRecipients from '@/views/Documents/Recipients.vue';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';

@Component(
  {
    components: {
      DocumentEvents,
      DocumentRecipients,
      SnackbarMessageHandler,
    },
  },
)
export default class Documents extends Vue {
  public document: Document = new Document({});
  public events: Array<Event> = new Array<Event>();
  public recipients: Array<Recipient> = new Array<Recipient>();
  public documentId = '';
  private documentService: DocumentService = new DocumentService();
  public deletingDocument = new Document({});
  public isDeletingDocument = false;
  public deletingDocumentConfirmation = '';

  $refs!: {
    documentId: HTMLFormElement;
  }

  mounted() {
    if (this.$route.params.id) {
      this.documentId = this.$route.params.id;
      this.searchDocument();
    }

    const element = this.$refs.documentId;
    element.$el.focus();
  }

  public requestDeleteDocument(document) {
    this.deletingDocument = document;
    this.isDeletingDocument = true;
  }

  public cancelDeleteDocument() {
    this.deletingDocument = new Document({});
    this.isDeletingDocument = false;
  }

  public recipientReset() {
    this.$snackbar.message('Recipient reset successfully.');
    this.reloadDocument();
  }

  public deleteDocument() {
    this.documentService.deleteDocument(this.deletingDocument.id).then(() => {
      this.$snackbar.message('Document deleted.');
      this.cancelDeleteDocument();
      this.$router.replace('/documents');
    }, (error) => {
      this.$snackbar.message(error.response.data.message);
    });
  }

  public reloadDocument() {
    this.documentService.getDocument(this.documentId).then((response) => {
      this.document = camelcaseKeysDeep(response.data) as Document;

      this.documentService.getDocumentEvents(this.documentId).then((eventResponse) => {
        this.events = eventResponse.data as Array<Event>;
      });
    });
  }

  public searchDocument() {
    this.documentService.getDocument(this.documentId).then((response) => {
      this.document = camelcaseKeysDeep(response.data) as Document;

      const newRoute = `/documents/${this.documentId}`;

      if (this.$router.currentRoute.path !== newRoute) {
        this.$router.replace(newRoute);
      }

      this.documentService.getDocumentEvents(this.documentId).then((eventResponse) => {
        this.events = eventResponse.data as Array<Event>;
      });
    }).catch((error) => {
      this.$snackbar.message(error.response.data.message);
    });
  }

  public reverify(document) {
    this.documentService.verifyDocument(document.id).then(() => {
      this.$snackbar.message('Document verification requested.');
    });
  }

  @Watch('$route')
  onRouteChanged(destination) {
    if (!destination.params.id) {
      this.document = new Document({});
      this.events = new Array<Event>();
      this.documentId = '';
    } else {
      this.documentId = destination.params.id;
      this.searchDocument();
    }
  }
}
